import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bill-pages',
  templateUrl: './bill-pages.component.html',
  styleUrls: ['./bill-pages.component.scss']
})
export class BillPagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
